import React, { useState } from "react";
import { useBluetooth } from "../BluetoothContext";
import { MdDriveFileRenameOutline } from "react-icons/md";
import customConnect from "../components/custom-connect-button.png";
import customFindRemote from "../components/find-remote-button.png";
import { useNavigate } from "react-router-dom";
import Loading from './Loading';

const Home: React.FC = () => {
  const { device, connectToBluetooth, renameRemote } = useBluetooth();
  const [popupVisible, setPopupVisible] = useState(false);
  const [newName, setNewName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleRenameClick = () => setPopupVisible(true);
  const handleClosePopup = () => setPopupVisible(false);

  const handleFindRemote = async () => {
    setLoading(true);
    try {
      await connectToBluetooth();
      navigate("/find-remote");
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (newName.trim()) {
      try {
        await renameRemote(newName);
        window.location.reload();
      } catch (error) {
        console.error("Error renaming remote:", error);
      }
    }
    setPopupVisible(false);
  };

  // Loading screen (your style)
  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {!device ? (
        // State 1: No device connected
        <div className="home-buttons">
          <div className="connect-container">
            <button onClick={connectToBluetooth} className="connect-button">
              <img src={customConnect} alt="connect" />
              CONNECT
            </button>
          </div>
          <div className="find-container">
            <button onClick={handleFindRemote} className="find-button">
              <img src={customFindRemote} alt="find remote" />
              FIND REMOTE
            </button>
          </div>
        </div>
      ) : (
        // State 2: Device connected
        <div className="connected-container">
          <div className="instructions" style={{ textAlign: "left" }}> 
            <h1><strong>Welcome!</strong></h1> 
            <p>
              You’re all set to customize your remote! Start by giving it a new name below to make it easy to identify. Once renamed, you can proceed to set up your remote using the link provided in the navigation bar.
            </p>
            <p>Connected to: <span style={{ color: "blue" }}>{device.name}</span></p>
            <p>From there, you’ll have the option to fine-tune your remote settings, such as configuring volume limits or adjusting how you switch channels. Take full control of your experience by personalizing these features to suit your needs.</p>
            <p>Let’s get started!</p>
          </div>

          <div className="rename-remote-button-container">
            <button
              className="rename-remote-button"
              onClick={handleRenameClick}
            >
              <MdDriveFileRenameOutline className="rename-icon" />
              Rename Remote
            </button>
          </div>

          {popupVisible && (
            <div className="popup-container-rename">
              <form className="popup-form" onSubmit={handleFormSubmit}>
                <h2>Rename Remote</h2>
                <p>Current Remote Name: {device.name}</p>
                <div className="input-row">
                  <label className="input-label">New Name:</label>
                  <input
                    type="text"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    placeholder="Enter new remote name"
                    className="rename-input"
                    required
                  />
                </div>
                <div className="popup-rename-buttons">
                  <button type="submit" className="submit-popup-button">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="close-popup-button"
                    onClick={handleClosePopup}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Home;
